module.exports = __webpack_public_path__ + "app-static/img/gz-btn.be31bc73.png";